// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#download,\n.gobackButton {\n  font-family: \"Noto Sans\", sans-serif, \"Noto Sans TC\", sans-serif;\n  margin-top: 50px;\n}\n.gobackButton {\n  letter-spacing: 0.3px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
